export default function Contato() {
    return (
        <>
            <section id="contact" className="portfolio section light-background">
                <div className="container section-title" data-aos="fade-up">
                    <div>
                        <span> Entrar em</span> <span className="description-title">Contato </span>
                    </div>
                </div>
                <div className="py-lg-16 py-10 bg-gray-200">
                    <div className="offset-lg-2 col-lg-8 col-md-12 col-12 text-center">
                        <h2 className="display-5 mt-4 mb-3 fw-bold">Vamos tirar sua ideia do papel?</h2>
                        <p className="lead px-lg-8 mb-6">
                            Conte em poucas linhas o que você precisa. Em seguida, marcamos uma conversa rápida para
                            alinhar prazos e próximos passos.
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
}
